import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, inject } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { ModalStateService } from "src/app/services/modal-service/modal-state.service";

@Component({
  selector: "app-chat-modal",
  templateUrl: "./chat-modal.component.html",
  styleUrls: ["./chat-modal.component.scss"],
  standalone: true,
  imports: [TranslateModule]
})
export class ChatModalComponent implements OnInit, OnDestroy {
  @Input() type: string = "failed";
  @Input() message: string = "";
  @Input() waitingTime: number = 0;
  @Input() checkResponse: () => string | null;
  @Input() onWaitingSuccess: (message: string) => void;
  @Input() onWaitingTimeout: () => void;
  @Input() onWaitingClose: () => void;

  countdown: number = 0;
  timerInterval;
  modalState: ModalStateService;
  changeDetector: ChangeDetectorRef;

  constructor() {
    this.modalState = inject(ModalStateService);
    this.changeDetector = inject(ChangeDetectorRef);
  }

  ngOnInit(): void {
    this.startTimer();
  }

  ngOnDestroy(): void {
    clearInterval(this.timerInterval);
  }

  startTimer(): void {
    if (this.type !== "waiting") return;

    this.countdown = this.waitingTime || 15;
    this.changeDetector.detectChanges();
    this.timerInterval = setInterval(() => {
      const response = this.checkResponse?.();
      if (response) {
        this.closeModal();
        setTimeout(() => this.onWaitingSuccess?.(response));
        return;
      }

      this.countdown -= 1;
      this.changeDetector.detectChanges();
      if (this.countdown <= 0) {
        this.closeModal();
        setTimeout(() => this.onWaitingTimeout?.());
      }
    }, 1000);
  }

  closeModal(): void {
    clearInterval(this.timerInterval);
    if (this.type === "waiting") {
      this.onWaitingClose?.();
    }
    this.modalState.triggerDismiss();
  }

  leaveMessage(): void {
    this.modalState.triggerDismiss("leave-message");
  }
}
